import React, { useState, useEffect } from 'react';
import axios from "axios";
import { AppstoreOutlined, MailOutlined, ExclamationCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import { Menu, Row, Col, Typography, Modal, message, Button, Carousel, Avatar, Tag, Select } from 'antd';
import NewTable from "./components/NewTable";
import AdminTeacherSwitchCourseModal from './components/AdminTeacherSwitchCourseModal';
import AdminTeacherAddCourseModal from './components/AdminTeacherAddCourseModal';
const { Title } = Typography;

const AdminTeacherCourseManage = () => {
    const [addOpen, setAddOpen] = useState(false);
    const [switchOpen, setSwitchOpen] = useState(false)
    const [search_date, set_search_date] = useState([])
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [custom_column, set_custom_column] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [role, set_role] = useState('');
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const { confirm } = Modal;
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([])
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const navigate = useNavigate();
    const titles = {
        '/cramSchool/admin/TeacherCourseManage/All': '教師調/補課管理',
        '/cramSchool/admin/TeacherCourseManage/SwitchCourse': '教師調課管理',
        '/cramSchool/admin/TeacherCourseManage/AddCourse': '教師補課管理',
    }
    const item = [
        {
            key: "/cramSchool/admin/TeacherCourseManage/All",
            label: `全部總覽`,
        },
        {
            key: "/cramSchool/admin/TeacherCourseManage/SwitchCourse",
            label: `調課管理`,
        },
        {
            key: "/cramSchool/admin/TeacherCourseManage/AddCourse",
            label: `補課管理`,
        },]
    const onSelect = (e) => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
        if (e.key == '/cramSchool/admin/TeacherCourseManage/SwitchCourse') {
            set_role('調課')
        } else if (e.key == '/cramSchool/admin/TeacherCourseManage/AddCourse') {
            set_role('補課')
        } else {
            set_role('')
        }
    }
    useEffect(() => {
        // console.log(role)
        // getData();
    }, [role])

    const [default_column, set_default_column] = useState([
        {
            title: '課程名稱',
            key: 'name',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: '調/補課時間',
            key: 'serial_name',
            dataIndex: 'serial_name',
            align: 'center',
        },
        {
            title: '調/補課狀態',
            key: 'role_permission',
            dataIndex: 'role_permission',
            render: (text, record, index) => (
                <>
                    {
                        record.role_permission && record.role_permission.map((value) => {
                            return (
                                <>
                                    <Tag>{value.permission_name}</Tag>
                                </>
                            )
                        })
                    }
                </>
            ),
            align: 'center',
        },
        {
            title: '教室',
            key: 'employment_time_end',
            dataIndex: 'employment_time_end',
            align: 'center',
        },
        {
            title: '學期編號',
            key: 'employment_time_start',
            dataIndex: 'employment_time_start',
            align: 'center',
        },
        {
            title: '操作',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (
                <>
                    {/* <button type="button" className="btn btn-link text-success" onClick={e => handleOnShow(record)}>修改</button>
                        <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button> */}
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { setTitle('修改'); setColor('f09a45'); setEdit(true); setOpen(true); setEditCard(record) }}>修改</Button>
                    {/* <Button danger type="text" onClick={() => showMessage(record.administration_id)}>刪除</Button> */}
                </>
            )
        },
        /* {
                            title: '',
            render: (text, record, index) => <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button>
        } */
    ])
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnDelete = (value) => {
        // axios
        //     .delete(`/cramSchool/api/permission/manage`, {
        //         data: [{ serial_name: value }]
        //     })
        //     .then((response) => {
        //         // console.log(response)
        //         if (response.data.status != 'success') {
        //             setOpen(false);
        //             messageApi.open({
        //                 type: 'error',
        //                 content: '刪除失敗',
        //             });
        //             reload();
        //         } else {
        //             setOpen(false);
        //             messageApi.open({
        //                 type: 'success',
        //                 content: '刪除成功',
        //             });
        //             reload();
        //         }
        //     })
    }
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        let params = {};
        if (role != '') {
            params = {
                cur_page: param?.current,
                size: param?.pageSize,
                custom_filter_key: checklist,
                custom_filter_value: param?.keyword,
                employment_time_start: search_date[0],
                employment_time_end: search_date[1],
                order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value })),
                type_name: role
            }
        } else {
            params = {
                cur_page: param?.current,
                size: param?.pageSize,
                custom_filter_key: checklist,
                custom_filter_value: param?.keyword,
                permission_time_start: search_date[0],
                permission_time_end: search_date[1],
                order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
            }
        }
        // return axios
        //     .get('/cramSchool/api/permission/manage', {
        //         params: params,
        //         // paramsSerializer: function (params) {
        //         //     const NewParams = Object.entries(params).map(([map_key, map_value]) => {
        //         //         if (map_key === 'order') {
        //         //             return Object.entries(map_value).map(([map_value_key,map_value_value], i) => {
        //         //                 return `order[${i}][column]=${map_value_key}&order[${i}][type]=${map_value_value}`;
        //         //             })
        //         //         }else if (map_key === 'custom_filter_key') {
        //         //             return map_value.map(map_item=>`custom_filter_key[]=${map_item}`).join("&");
        //         //         }else{
        //         //             return `${map_key}=${map_value}`;
        //         //         }
        //         //     })
        //         //     return NewParams.join("&")
        //         // },
        //     })
        //     .then((response) => {
        //         set_total(response.data.total)
        //         setDatas(response.data.data);
        //         get_picture(response.data.data);
        //     })
        //     .finally(() => {
        //         set_loading(false)
        //     })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let serial_name = value['serial_name']
            // console.log(student_id);
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (serial_name == value.serial_name) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        // axios
        //     .post('/cramSchool/api/custom_table_setting', [
        //         {
        //             table_name: 'permission',
        //             table_data: [
        //                 ...extra_columns.map(map_item => ({
        //                     column_key: map_item.key,
        //                     column_name: map_item.key
        //                 }))
        //             ]
        //         }
        //     ])
    }
    const get_table_setting = () => {
        // axios
        //     .get('/cramSchool/api/custom_table_setting', {
        //         params: {
        //             custom_table_setting_table_name: 'permission'
        //         }
        //     })
        //     .then(response => {
        //         set_extra_columns(response.data.map(map_item => ({
        //             title: map_item.column_key,
        //             key: map_item.column_key,
        //             dataIndex: map_item.column_key,
        //         })))
        //     })
    }
    useEffect(() => {
        reload()
    }, [search_date])
    useEffect(() => {
    }, []);
    // getData();
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const handleOnDeleteRow = () => {
        // const deleterow = [];
        //     deleterow.push({ 'serial_name': value })
        // })
        // selectedRowKeys && selectedRowKeys.map((value, i) => {
        // // console.log(deleterow)
        // axios
        //     .delete(`/cramSchool/api/permission/manage`, {
        //         data: deleterow
        //     })
        //     .then((response) => {
        //         // console.log(response)
        //             setOpen(false);
        //             messageApi.open({
        //                 type: 'error',
        //                 content: '刪除失敗',
        //             });
        //         if (response.data.status != 'success') {
        //         } else {
        //             setOpen(false);
        //             reload();
        //             messageApi.open({
        //                 type: 'success',
        //             });
        //             reload();
        //                 content: '刪除成功',
        //         }
        //     })
    }
    const handleOnAddRow = () => {
        setColor('d65b77');
        setTitle(role == '調課' ? '新增調課' : '新增補課');
        role == '調課' ? setSwitchOpen(true) : setAddOpen(true);
        setEdit(false);
        setOpen(true);
        setEditCard({});
    }
    const handleSearchDate = (date) => {
        set_search_date(date);
        const handleEdit = () => {
        }
        // if (editcard['role_permission'].length == 0) {
        //     messageApi.open({
        //         type: 'warning',
        //         content: '請勾選人員權限管理',
        //     });
        //     axios
        //         .patch(`/cramSchool/api/permission/manage`, [{ ...editcard }])
        // } else {
        //         .then((response) => {
        //             if (response.data.status == 'failure') {
        //                 setOpen(false);
        //                 messageApi.open({
        //                     content: '修改失敗',
        //                     type: 'error',
        //                 });
        //                 reload();
        //             } else {
        //                 setOpen(false);
        //                     type: 'success',
        //                     content: '修改成功',
        //                 messageApi.open({
        //                 });
        //             }
        //         })
        //                 reload();
        // }
    }
    const handleSubmit = () => {
        //     .post(`/cramSchool/api/permission/manage`, [{ ...editcard }])
        //     .then((response) => {
        // axios
        //         if (response.data.status == 'failure') {
        //             setOpen(false);
        //             messageApi.open({
        //                 type: 'error',
        //                 content: '新增失敗',
        //             });
        //             getData();
        //         } else {
        //             setOpen(false);
        //             messageApi.open({
        //                 type: 'success',
        //                 content: '新增成功',
        //             });
        //             getData();
        //         }
        //     })
    }
    useEffect(() => {
        // console.log(data)
        datas.forEach(each_item => {
            if (each_item.serial_name === editcard.serial_name) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [datas])
    return (
        <>
            {contextHolder}
            <AdminTeacherSwitchCourseModal
                open={switchOpen}
                setOpen={setSwitchOpen}
                title={title} />
            <AdminTeacherAddCourseModal
                open={addOpen}
                setOpen={setAddOpen}
                title={title} />
            <Menu
                onSelect={onSelect}
                selectedKeys={selecte_keys}
                mode="horizontal"
                items={item}
            // style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}
            />
            <Row gutter={[8, 8]} style={{ paddingTop: '10px' }}>
                <Col span={24} style={{ paddingLeft: '20px' }}>
                    <Select
                        style={{ width: 150 }}>

                    </Select>
                </Col>
                <Col span={24}>
                    <NewTable
                        force_reload={force_reload}
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'PermissionList'}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add_button_title={role == '調課' ? '新增調課' : '新增補課'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        add={role == '' ? false : true}
                        rowkey={'serial_name'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        rangepicker_title={'起始時間'}
                        handleSearchDate={handleSearchDate}//搜尋日期
                    ></NewTable>
                </Col>
            </Row>
        </>
    )

};
export default AdminTeacherCourseManage;